var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-5 overflow-auto",attrs:{"fluid":""},domProps:{"innerHTML":_vm._s(_setup.importdataHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }